import { GraphQLClient, RequestMiddleware, ResponseMiddleware } from 'graphql-request'
import { toast } from 'react-toastify'

const requestMiddleware: RequestMiddleware = async (request) => {
  return request
}

const responseMiddleware: ResponseMiddleware = (response: any) => {
  if (!(response instanceof Error) && response.errors) {
    // const traceId = response.headers.get(`x-b3-trace-id`) || `unknown`
    // console.error(
    //   `[${traceId}] Request error:
    //     status ${response.status}
    //     details: ${response.errors.map((_: any) => _.message).join(`, `)}`
    // )
    const errorMessage = response?.errors[0]?.message
    const debugErrorMessage = response?.errors[0]?.debugMessage
    const errorPath = response?.errors[0]?.path?.[0]

    if (
      response.errors[0]?.extensions?.category === 'graphql-authorization' &&
      errorPath !== 'generateCustomerToken' &&
      errorPath !== 'cart'
    ) {
      localStorage.removeItem('token')
      localStorage.removeItem('cartId')
      localStorage.removeItem('loginSocial')
      // window.location.replace(`${window.location.origin}/login`)
    }
    if (errorMessage && errorPath !== 'cart' && errorPath !== 'addProductsToCart') {
      // if (errorMessage?.includes('Không thể lấy được')) {
      //   throw Error(errorMessage)
      // }

      if (!errorMessage?.includes('Internal server error')) {
        toast.error(errorMessage)
      } else {
        toast.error(debugErrorMessage)
      }
    }
    if (response.errors[0]?.extensions?.category === 'graphql-input') return
  }
  return response
}

// Đảm bảo API URL là absolute URL
const getApiUrl = () => {
  const apiUrl = process.env.NEXT_PUBLIC_API_URL
  if (!apiUrl) {
    throw new Error('NEXT_PUBLIC_API_URL environment variable is not set')
  }
  // Nếu là relative URL, chuyển thành absolute URL
  if (apiUrl.startsWith('/')) {
    // Trong SSR/build, cần absolute URL
    if (typeof window === 'undefined') {
      // Fallback hoặc throw error trong build time
      throw new Error(
        'NEXT_PUBLIC_API_URL must be an absolute URL (e.g., https://api.example.com/graphql)'
      )
    }
    return `${window.location.origin}${apiUrl}`
  }
  return apiUrl
}

const graphQLClient = new GraphQLClient(getApiUrl(), {
  requestMiddleware,
  responseMiddleware,
  errorPolicy: 'all',
})

if (typeof window !== 'undefined') {
  graphQLClient.setHeaders({
    Authorization:
      localStorage && localStorage.getItem('token')
        ? 'Bearer ' + localStorage.getItem('token')
        : '',
    'Content-Type': 'application/json',
    accept: 'application/json',
    store:
      localStorage && localStorage.getItem('language')
        ? localStorage.getItem('language') || 'vi'
        : '',
  })
}

const graphQLClientGET = new GraphQLClient(getApiUrl(), {
  requestMiddleware,
  responseMiddleware,
  errorPolicy: 'all',
  method: 'GET',
})

if (typeof window !== 'undefined') {
  graphQLClientGET.setHeaders({
    Authorization:
      localStorage && localStorage.getItem('token')
        ? 'Bearer ' + localStorage.getItem('token')
        : '',
    'Content-Type': 'application/json',
    accept: 'application/json',
    store:
      localStorage && localStorage.getItem('language')
        ? localStorage.getItem('language') || 'vi'
        : '',
  })
}

export const setTokenGraphQL = (token: string) => {
  graphQLClient.setHeaders({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    accept: 'application/json',
  })
}

export { graphQLClient, graphQLClientGET }
